import { Link } from "react-router-dom";
import { DashboardLayout } from "../../Layout/DashboardLayout";
import CustomFilters from "../../Components/CustomFilters";
import { useEffect, useState, useCallback } from "react";
import CustomTable from "../../Components/CustomTable";
import moment from "moment";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEllipsisV, faTimes } from "@fortawesome/free-solid-svg-icons";
import { deleteRequest, getRequest, patchRequest } from "../../Util/requests";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { errorModal, questionModal, successModal } from "../../Components/CustomModal";
import CustomLoader from "../../Components/CustomLoader";
import { placeholderImage } from "../../Assets/images";

const ROLES_HEADER = [
    { key: "id", title: "S.No" },
    { key: "name", title: "Name" },
    { key: "banner", title: "Banner" },
    { key: "CreatedAt", title: "Created" },
    { key: "actions", title: "Actions" },
];

const ScofaDashboardLinkTypeManagement = () => {
    const [data, setData] = useState([]);
    const [offset, setOffset] = useState(0);
    const [loader, setLoader] = useState(false);
    const [entries, setEntries] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [filterSearchValue, setFilterSearchValue] = useState("");
    const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
    const [isListPositionUpdated, setIsListPositionUpdated] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchValue(filterSearchValue);
            setOffset(0); // Reset offset on new search
        }, 2000);

        return () => clearTimeout(timer);
    }, [filterSearchValue]);

    const fetchData = useCallback(async () => {
        try {
            setLoader(true);
            const queryParams = new URLSearchParams({
                limit: entries,
                offset: offset,
                search: debouncedSearchValue
            }).toString();

            const response = await getRequest(`/api/user/dashboard-link-types/?${queryParams}`);

            if (response && !response.data.error) {
                setData(response.data.data || []);
                setTotalCount(response.data.count || 0);
            } else {
                console.error("Fetch error:", response?.data?.message);
            }
        } catch (error) {
            console.error("Request failed:", error);
        } finally {
            setLoader(false);
        }
    }, [entries, offset, debouncedSearchValue]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const onSortEnd = (result) => {
        if (!result.destination) return;

        const oldIndex = result.source.index;
        const newIndex = result.destination.index;
        if (oldIndex === newIndex) return;

        const reordered = Array.from(data);
        const [moved] = reordered.splice(oldIndex, 1);
        reordered.splice(newIndex, 0, moved);
        setData(reordered);
        setIsListPositionUpdated(true);
    };

    const updateOrdering = async () => {
        questionModal.fire({
            title: `Do you want to Update Order?`,
            confirmButtonText: `yes`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                await updateOrderingAPI();
            }
        });
    };

    const updateOrderingAPI = async () => {
        setLoader(true);
        try {
            const payload = data.map((item, index) => ({
                id: item.id,
                sequence: offset + index + 1,
            }));

            const response = await patchRequest('/api/user/dashboard-link-types/', payload);

            if (response?.data && !response.data.error) {
                successModal.fire({ text: 'Order updated successfully' });
                setIsListPositionUpdated(false);
                fetchData();
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoader(false);
        }
    };

    const handleDeleteLinkType = async (id) => {
        try {
            setLoader(true);
            const result = await questionModal.fire({
                title: `Do you want to delete this Main category?`,
                confirmButtonText: "Delete",
            });
            if (result.isConfirmed) {
                const response = await deleteRequest(`/api/user/dashboard-link-types/${id}`);
                if (response && !response.data.error) {
                    successModal.fire({
                        text: "Main category deleted successfully",
                        confirmButtonText: "Continue",
                    });
                    setData(prevData => prevData.filter(item => item.id !== id));
                } else {
                    errorModal.fire({
                        text: "Unable to delete this Main category",
                        confirmButtonText: "Continue",
                    });
                }
            }

        } catch (err) {
            console.error("Delete failed:", err);
        } finally {
            setLoader(false);
        }
    };

    return (
        <DashboardLayout>
            <div className="container-fluid">
                <div className="row mb-3">
                    <div className="col-lg-8 mb-2">
                        <h2 className="mainTitle">Main category</h2>
                    </div>
                    <div className="col-lg-4 text-end mb-2">
                        {isListPositionUpdated && (
                            <button className="customButton secondaryButton me-2" onClick={updateOrdering}>
                                Update Order
                            </button>
                        )}
                        <Link
                            to="/scofa/main-categories/add"
                            className="customButton primaryButton"
                        >
                            Add Main category
                        </Link>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-12">
                        <CustomFilters
                            enteries={entries}
                            totalCount={totalCount}
                            entriesFilter={true}
                            setEnteries={(e) => setEntries(e.target.value)}
                            filterSearch={true}
                            filterSearchValue={filterSearchValue}
                            setFilterSearchValue={setFilterSearchValue}
                        />
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-12">
                        {loader ? (
                            <CustomLoader />
                        ) : (
                            <DragDropContext onDragEnd={onSortEnd}>
                                <Droppable droppableId="link-type-list">
                                    {(provided) => (
                                        <div ref={provided.innerRef} {...provided.droppableProps}>
                                            <CustomTable headers={ROLES_HEADER}>
                                                <tbody>
                                                    {data.map((item, index) => (
                                                        <Draggable key={item.id} draggableId={`type-${item.id}`} index={index}>
                                                            {(provided, snapshot) => (
                                                                <tr
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    className={snapshot.isDragging ? 'dragging' : ''}
                                                                >
                                                                    <td>{offset + index + 1}</td>
                                                                    <td>{item.name}</td>
                                                                    <td>
                                                                        <img
                                                                            src={item.banner && item.banner !== '/media/assets/no_image.png' ? item.banner : placeholderImage}
                                                                            alt={item.name}
                                                                            style={{ width: "200px", height: "56px", objectFit: "cover", borderRadius: "5px", }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        {moment.utc(item.created_at).local().format("MM-DD-YYYY")}
                                                                        <br />
                                                                        <small className="text-muted">
                                                                            {moment.utc(item.created_at).local().format("HH:mm:ss")}
                                                                        </small>
                                                                    </td>
                                                                    <td>
                                                                        <Dropdown className="tableDropdown">
                                                                            <Dropdown.Toggle
                                                                                variant="transparent"
                                                                                className="notButton classicToggle"
                                                                            >
                                                                                <FontAwesomeIcon icon={faEllipsisV} />
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu align="end" className="tableDropdownMenu">
                                                                                <Link
                                                                                    to={`/scofa/main-categories/edit/${item.id}`}
                                                                                    className="dropdown-item"
                                                                                >
                                                                                    <FontAwesomeIcon icon={faEdit} /> Edit
                                                                                </Link>
                                                                                <Dropdown.Item
                                                                                    className="dropdown-item"
                                                                                    onClick={() => handleDeleteLinkType(item.id)}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faTimes} /> Delete
                                                                                </Dropdown.Item>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                    {data.length === 0 && (
                                                        <tr>
                                                            <td colSpan={ROLES_HEADER.length} className="text-center">No Link Types found.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </CustomTable>
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        )}
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default ScofaDashboardLinkTypeManagement;